module.exports = __webpack_public_path__ + "img/hr-green-croton-06.f368f77a.png";